import dayjs from "dayjs";
import "dayjs/locale/da";
dayjs.locale("da");

export function formatSmartTimestamp(
  timestamp: number,
  options?: {
    yesterdayLabel?: string;
  },
): string {
  const date = dayjs(timestamp);
  const now = dayjs();

  const yesterdayLabel = options?.yesterdayLabel ?? "I går";

  if (date.isSame(now, "day")) {
    return date.format("HH:mm");
  }

  if (date.isSame(now.subtract(1, "day"), "day")) {
    return `${yesterdayLabel} ${date.format("HH:mm")}`;
  }

  if (date.isSame(now, "week")) {
    return date.format("dddd HH:mm");
  }

  return date.format("DD.MM.YYYY - HH:mm");
}
